import { render, staticRenderFns } from "./PickingForm.vue?vue&type=template&id=c476e4e4&"
import script from "./PickingForm.vue?vue&type=script&lang=js&"
export * from "./PickingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports